import { Injectable } from '@angular/core';
import { EProductWizardMode } from '@gelato-api-ui/core/e-commerce/e-product-wizard-mode.enum';

@Injectable()
export class ECommerceProductWizardInitializationRouteService {
  getRoute(mode: EProductWizardMode, storeId: string, productId: string): any[] {
    return [`/stores/${storeId}/products/${this.getModeSpecificRoutePart(mode)}/${productId}`];
  }

  private getModeSpecificRoutePart(mode: EProductWizardMode): string {
    switch (mode) {
      case EProductWizardMode.EDIT_PRODUCT_TEMPLATE:
        return 'edit-product-template';
      case EProductWizardMode.EDIT_DRAFT:
        return 'edit-draft';
      case EProductWizardMode.EDIT_MEDIA:
        return 'edit-media';
      case EProductWizardMode.EDIT_DETAILS:
        return 'edit-details';
      case EProductWizardMode.EDIT_PRICES:
        return 'edit-prices';
      default:
        return 'edit-designs';
    }
  }
}
